import React from 'react';
import { IMG } from '../data/constants';

const Accreditations = ({ t }) => (
  /* full-width bg */
  <div className="w-full bg-white border-b border-line">
    {/* max-width content */}
    <div className="max-w-[1440px] mx-auto px-[120px] py-16 box-border flex flex-col gap-8">

      <h2 className="m-0 font-heading font-medium text-[34px] leading-[1.15] text-navy tracking-[-0.015em]">
        {t.accredLabel}
      </h2>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        {t.accred.map((a, i) => (
          <div
            key={a.name}
            className="box-border p-6 bg-paper rounded-[4px] flex flex-col gap-4"
          >
            {/* Logo */}
            <div className="flex items-center justify-center">
              <img src={IMG.accred[i]} alt={a.name} className="w-[200px] h-[100px] object-contain" />
            </div>

            {/* Name & sub */}
            <div className="flex flex-col gap-1 text-center items-center">
              <span className="font-heading font-semibold text-[17px] leading-[1.25] text-navy">{a.name}</span>
              <span className="text-sm text-muted">{a.sub}</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  </div>
);

export default Accreditations;
